<script setup lang="ts">
import { useNuxtApp } from '#app'
import { onMounted } from 'vue'
import { useOperationNationale } from '~/composables/useOperationNationale'

const { informations, fetchInformations, daysLeft } = useOperationNationale('tournee-ete')

const { $filters } = useNuxtApp()

onMounted(async () => {
  await fetchInformations()
})
</script>

<template>
  <div
    id="mission-count-down-tournee-ete"
    class="relative p-6 w-full bg-[#F5F7FF] border border-[#BDCDFF] rounded shadow-lg"
  >
    <div class="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
      <div class="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        <img
          src="/images/stickers/sticker-tournee-ete.svg"
          alt="La tournée d’été"
          width="120"
          height="120"
          class="flex-none w-[96px] h-[96px] sm:w-[120px] sm:h-[120px]"
        />
        <div class="">
          <div class="text-[#161616] text-base mb-1">
            En proposant votre aide pour cette mission, vous rendez l’été 2025 plus solidaire grâce
            à
            <strong>La tournée d’été</strong>.
          </div>
          <div v-if="informations.participations_count > 0" class="text-[#666666] text-sm">
            {{
              $filters.pluralize(
                informations.participations_count,
                'bénévole participe',
                'bénévoles participent',
              )
            }}
            déjà !
          </div>
        </div>
      </div>
      <div v-if="daysLeft > 0" class="border border-[#E3E3FD] rounded p-4 sm:p-6">
        <div class="sm:hidden text-sm text-[#666666] text-center">
          Plus que
          <span class="font-bold text-base text-[#161616]">{{
            $filters.pluralize(daysLeft, 'jour', 'jours')
          }}</span>
          pour participer
        </div>
        <div class="hidden sm:block sm:w-[104px] text-center">
          <div class="text-[#666666] text-sm">Plus que</div>
          <div class="text-[#161616] font-bold text-2xl">
            {{ $filters.pluralize(daysLeft, 'jour', 'jours') }}
          </div>
          <div class="text-[#666666] text-sm">pour participer</div>
        </div>
      </div>
    </div>
  </div>
</template>
